"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DummyWallet = void 0;
const web3_js_1 = require("@solana/web3.js");
exports.DummyWallet = {
    publicKey: web3_js_1.PublicKey.default,
    signTransaction: () => {
        throw new Error("Cannot sign transaction without a wallet");
    },
    signAllTransactions: () => {
        throw new Error("Cannot sign transactions without a wallet");
    },
};
